import UserSubmissionHistoryWidget from './UserSubmissionHistoryWidget';

export default UserSubmissionHistoryWidget;
